import React from 'react';
import Icon from '../../../components/AppIcon';

const CommuneSelector = ({ communes, selectedCommune, onCommuneSelect }) => {
  return (
    <div className="bg-surface border-border border-b-0 border-none">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-5 sm:py-6">
        <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between gap-3 mb-5">
          <div>
            <h2 className="text-lg sm:text-xl font-heading font-semibold text-text-primary mb-0.5">
              Choisir une Commune
            </h2>
            <p className="text-sm text-text-secondary">
              Découvrez les {communes?.length} communes d'Abidjan
            </p>
          </div>
          
          <div className="flex items-center space-x-2 text-sm text-text-secondary">
            <Icon name="Map" size={16} />
            <span>Vue d'ensemble</span>
          </div>
        </div>
        
        {/* Grid: 2 cols mobile → 3 cols sm → 4 cols md → 5 cols lg */}
        <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-5 gap-2 sm:gap-3">
          {communes?.map((commune) =>
          <button
            key={commune?.id}
            onClick={() => onCommuneSelect(commune)}
            className={`p-3 sm:p-4 rounded-xl border-2 transition-all duration-300 text-left group hover:shadow-warm min-h-[80px] sm:min-h-[96px] touch-manipulation border-none ${
            selectedCommune?.id === commune?.id ?
            'border-brand-gold bg-brand-gold/5 shadow-warm' :
            'border-border bg-white hover:border-brand-gold/50'}`
            }>

              <div className="flex items-center justify-between mb-1.5 sm:mb-2">
                <Icon
                name="MapPin"
                size={16}
                className={`transition-colors duration-300 flex-shrink-0 ${
                selectedCommune?.id === commune?.id ?
                'text-brand-gold' : 'text-text-secondary group-hover:text-brand-gold'}`
                } />

                <span className={`text-xs px-1.5 py-0.5 rounded-full leading-tight ${
              commune?.isPopular ?
              'bg-accent/10 text-accent' : 'bg-surface text-text-secondary'}`
              }>
                  {commune?.isPopular ? 'Pop.' : `${commune?.propertyCount}`}
                </span>
              </div>
              
              <h3 className={`font-medium text-sm mb-0.5 transition-colors duration-300 leading-tight ${
            selectedCommune?.id === commune?.id ?
            'text-brand-gold' : 'text-text-primary group-hover:text-brand-gold'}`
            }>
                {commune?.name}
              </h3>
              
              <p className="text-xs text-text-secondary line-clamp-2 hidden sm:block">
                {commune?.shortDescription}
              </p>
            </button>
          )}
        </div>
      </div>
    </div>);

};

export default CommuneSelector;